import moment from "moment";

function formatBookingPeriod(date) {
  return moment(date, 'YYYY-MM-DD')
    .locale("en")
    .format("MMMM DD");
}

function formatBookingSearchPeriod(date) {
  return moment(date)
    .locale("en")
    .format("MMMM DD YYYY");
}

function formatNoteDateTime(date) {
  return moment(date)
    .locale("en")
    .format('lll');
}

function formatDate(date, format = 'YYYY-MM-DD') {
  let date_ = moment(date, 'YYYY-MM-DD HH:mm:ss');

  if (!date_.isValid()) {
    return ''
  }

  return date_.format(format);
}

export {
  formatBookingPeriod,
  formatNoteDateTime,
  formatBookingSearchPeriod,
  formatDate
};